module.exports = __webpack_public_path__ + "static/media/ex-logo.6a688db9.png";